import { Image as ImageIcon } from 'lucide-react'
import { Switch } from '@/components/ui/switch'

export function ProfileExtras({
  editing,
  publicVisibility,
  onVisibilityChange,
}: {
  editing: boolean
  publicVisibility: boolean
  onVisibilityChange: (checked: boolean) => void
}) {
  return (
    <>
      <div className="flex items-center gap-4">
        <span className="text-body-sm text-muted-foreground sm:w-40">Public visibility</span>
        <Switch
          aria-label="Public visibility"
          checked={publicVisibility}
          disabled={!editing}
          onCheckedChange={onVisibilityChange}
        />
      </div>
      <div className="flex items-center gap-4">
        <span className="text-body-sm text-muted-foreground sm:w-40">Photo</span>
        <div className="flex size-24 items-center justify-center rounded-md border border-dashed border-border bg-muted">
          <ImageIcon className="size-6 text-muted-foreground" role="img" aria-label="Empty photo" />
        </div>
      </div>
    </>
  )
}
